import Vue from 'vue';
import Vuex from 'vuex';

import AuthStore from 'ays-shared/authStore';
import CacheStore from 'ays-shared/cacheStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: AuthStore,
    cache: CacheStore,
  },
});
